import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  pageContainer: theme => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing.xs};
  `,

  title: theme => css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: ${theme.spacing.md};
    margin-top: ${theme.spacing.xxs};
    padding: ${theme.spacing.xxs} 0;
    align-items: center;
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      justify-content: space-between;
    }
    span {
      display: flex;
      align-items: center;
    }
  `,

  tabsContainer: css`
    width: 100%;
  `,

  cardsContainer: theme => css`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    margin-bottom: ${theme.spacing.xxs};
    width: 100%;
    gap: ${theme.spacing.xs};
    @media (min-width: ${theme.grid.breakpoint['2xl']}) {
      ::-webkit-scrollbar {
        width: ${theme.spacing.xxs};
      }
      ::-webkit-scrollbar-track {
        background-color: ${theme.colors.background.gray};
      }
      ::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.neutral[100]};
        border-radius: ${theme.border.radius.lg};
      }
    }
  `,

  container: css`
    width: 100%;
    display: flex;
    flex-direction: column;
  `,

  containerIlustration: theme => css`
    margin-top: ${theme.spacing.md};
    padding: ${theme.spacing.sm};
    justify-self: center;
    align-content: center;
  `,

  containerAllActiveAccounts: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,

  backStepperWrapper: css`
    width: 100%;
    display: flex;
    justify-items: flex-start;
  `,

  addNewAccountWrapper: theme => css`
    display: flex;
    justify-content: center;
    margin-top: ${theme.spacing.xs};
  `,
})

export { useStyles }
